export default __webpack_public_path__ + "static/media/big_logo.e3f57945.png";